<template>
  <div class="nav-header">
    <!-- <h2>{{name}}</h2> -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item v-for="(item, index) in list" :key="index">{{item}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'navHeader',
  props: {
    titleList: {
      type: Array,
      default: () => ['', '']
    }
  },
  data () {
    return {
      name: this.titleList[this.titleList.length - 1],
      list: this.titleList
    }
  },
  watch: {
    titleList (newV) {
      this.list = newV
    }
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="less">
.nav-header {
  position: absolute;
  top: -110px;
  left: 20px;
  box-sizing: border-box;
  height: 60px;
  background-color: #fffafa;
  overflow: hidden;
  .el-breadcrumb {
    height: 60px;
    font-size: 18px;
    line-height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navHeader.vue